export const bulkMapping = {
  "bulk_mapping_dialog.title": `Bulk Upload Mappings (CSV)`,
  "bulk_mapping_dialog.description": `Bulk upload all of your mappings based on provided format in sample CSV`,
  "bulk_mapping_dialog.starting_execution_order": `Starting Execution Order`,
  "bulk_mapping_dialog.execution_order_placeholder": `e.g. 500`,
  "bulk_mapping_dialog.download_sample_csv": `Download sample.csv`,
  "bulk_mapping_dialog.upload_documents": `Upload Your Documents`,
  "bulk_mapping_dialog.drag_and_drop": `Drag and Drop your files here`,
  "bulk_mapping_dialog.browse_files": `Browse Files`,
  "bulk_mapping_dialog.max_file_size": `Maximum 5MB sized CSV file only`,
  "bulk_mapping_dialog.keep_previous_mapping": `Keep previous Mappings`,
  "bulk_mapping_dialog.upload_mapping": `Upload Mappings`,
  "bulk_mapping_dialog.description_label": `Notes`,
  "bulk_mapping_dialog.description_placeholder": `e.g. vendor mappings`,
  "bulk_mapping_dialog.description_max_length": `Notes cannot exceed 100 characters`,
};
